import { once } from 'lodash';

export const requestNewToken = once((oidClient, state?: any) => {
  return oidClient.signinRedirect(state);
});
